// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1gxaC","inner":"Form_inner__2xuHB","range":"Form_range__1IIhS","name":"Form_name__1Ys3d","actions":"Form_actions__L_ktx"};